import React, {Component} from 'react';
import axios from "axios/index";
import {Row} from "reactstrap";

import {API_URL} from "./../../config/Config";
import PlanItem from "./../plans/PlanItem";
import PageLoader from "./../loader/PageLoader";

export default class MerchantPackage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            business_id:0,
            plans:[]
        };
    }
    async componentDidMount(){
         await this.getPlans();

        let business_id = await this.props.id;
        if (business_id){
            this.setState({business_id});
        }
    }
    async getPlans() {
        let response = await axios.get(`${API_URL}plan`);
        if (response.status < 200 || response.status > 300) {
            const error = new Error(response.statusText);
            error.response = response;
            console.log(error);
            alert("خطایی در هنگام دریافت اطلاعات رخ داد.");
        }else{
            let plans = response.data.data;
            this.setState({plans});
        }
        console.log("done");
        this.setState({loading: true});
    }

    render() {
        const {loading,business_id,plans} = this.state;
        return (
            <div>
                {!loading ? <PageLoader type="bubbles" color="#4fbfa8"/> :
                    <Row className="mt-4 mb-4">

                        {plans.map( plan =>
                            <PlanItem key={plan.id} data={plan} businessId={business_id}/>
                        )}
                    </Row>
                }


            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/merchants/MerchantPackages.js